import React from 'react';
import { images } from '../../shared/assets';
import './GlacierVideoSection.css';

export const GlacierVideoSection: React.FC = () => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  
  // Use the glacier video URL from assets
  const videoSrc = images.destinationsBgVideo;
  
  React.useEffect(() => {
    // Ensure video plays
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.error('Glacier video autoplay failed:', err);
      });
    }
  }, [videoSrc]);
  
  return (
    <section className="glacier-video-section">
      <div className="glacier-video-section__container">
        <video
          ref={videoRef}
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="glacier-video-section__video"
          onLoadedData={() => console.log('Glacier video loaded:', videoSrc)}
          onError={(e) => console.error('Glacier video error:', e, videoSrc)}
        />
      </div>
    </section>
  );
};